import React from 'react'

const Button = ({
  onClick,
  disabled = false,
  backgroundColor,
  hoverBackgroundColor,
  textColor,
  className = "",
  icon = null,
  text,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-2 px-4 py-2 font-medium rounded-lg transition-colors duration-200 ${backgroundColor} ${hoverBackgroundColor} ${textColor} ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {icon && icon}
      {text}
    </button>
  );
};

export default Button